var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 16,
  height: 16,
  rx: 8,
  fill: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.563 11.667H8.498V7.645H7.434M8.189 4.64h0a.236.236 0 110 0",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHJ4PSI4IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTkuNTYyNjMgMTEuNjY2OEg4LjQ5ODExVjcuNjQ1MjZINy40MzM1OSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC4xODg4MiA0LjYzOTY3TDguMTg5MjMgNC42MzkyNkM4LjI4MTQ5IDQuNTQ3MjMgOC40MzA4NiA0LjU0NzM3IDguNTIyOTQgNC42Mzk1N0M4LjYxNTAyIDQuNzMxNzcgOC42MTQ5NyA0Ljg4MTE0IDguNTIyODQgNC45NzMyN0M4LjQzMDcgNS4wNjU0MSA4LjI4MTMzIDUuMDY1NDYgOC4xODkxMyA0Ljk3MzM4QzguMDk2OTMgNC44ODEzIDguMDk2NzkgNC43MzE5MyA4LjE4ODgyIDQuNjM5NjciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { Svg16 as ReactComponent };